import React from 'react';


// import Hero from "./components/hero/Hero";
import Find from './components/find/Find';
import Baner from './components/baners/Baner';
import News from './components/news/News';
import Heromtavari from './components/hero/Heromtavari';

function App() {
  return (
    <div >
     
     <Heromtavari />
     <Baner />
     <News />
     <Find />
   
    </div>
    
  );
}

export default App;
